// Copyright (c) 2020 Comsearch, Inc., All rights reserved

import { loadingToggler } from 'redux/modules/loading'
import { setPcnRenewalAdminTransactions } from 'redux/modules/projectTracker/actions'

import {
  fetchWrapper,
} from 'helpers/api'

const getPcnRenewalAdminTransactions = (ignoreCache = false) => (dispatch, getState) => (
  dispatch(loadingToggler(
    async () => {
      const { renewalAdmin } = getState().projectTracker

      // if the data isn't expired yet, just return what we have in redux store.
      if (ignoreCache === false && renewalAdmin.dataExpiration > Date.now()) {
        return renewalAdmin.data
      }

      try {
        const data = await fetchWrapper('/pcnRenewalAdmin')

        // add a combination of pathId and transactionId as a uniqueId in case transactionId is null.
        const newData = data.reduce((a, d) => {
          d.__uniqueId = d.pathId + '_' + d.transactionId
          a.push(d)
          return a
        }, [])

        dispatch(setPcnRenewalAdminTransactions(newData))
      } catch (err) {
        throw err
      }
    }
  ))
)

export default getPcnRenewalAdminTransactions
